<template>
    <div>

        <!-- 工具栏 -->
        <div>

            <div v-show="showAdvanceSearchView" class="pageNormal"
                 style="border: 1px solid #EBEEF5; border-radius:5px; box-sizing:border-box; padding:15px 15px 15px 15px; margin: 10px 0px;">
                <el-row>
                    <el-col :span="12">
                        商户名称：<el-input clearable v-model="searchValue.merchName" placeholder="商户名称" size="mini" maxlength="30" style="width:300px" />
                    </el-col>
                    <el-col :span="6">
                        商户号：<el-input clearable v-model="searchValue.mid" placeholder="商户号" size="mini" maxlength="15" style="width:150px" onKeyUp="value=value.replace(/\D/g,'')" />
                    </el-col>
                    <el-col :span="6">
                        终端号：<el-input clearable v-model="searchValue.tid" placeholder="终端号" size="mini" maxlength="8" style="width:150px" onKeyUp="value=value.replace(/[\W]/g,'')"/>
                    </el-col>
                </el-row>
                <el-row type="flex" style="margin-top:15px;" justify="space-start">
                    <el-col :span="6">
                        交易渠道：<el-select clearable v-model="searchValue.channel" placeholder="交易渠道" size="mini" style="width:150px">
                        <el-option class="pageNormal"
                                   v-for="item in acqChannels"
                                   :key="item.code"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                        交易类型：
                        <el-select clearable v-model="searchValue.transType" placeholder="交易类型" size="mini" class="style-input-width">
                            <el-option class="f12"
                                       v-for="item in transTypes"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        交易日期：
                        <el-date-picker
                                v-model="searchValue.transDateScope"
                                value-format="yyyyMMdd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-col>
                </el-row>

            </div>

            <div style="display: flex;justify-content: space-between">
                <div>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-search" @click="initTransJnl">查询</el-button>
                    <el-button type="success" icon="el-icon-download" @click="exportData">导出数据</el-button>
                </div>
            </div>

        </div>

        <!-- 数据展示栏 -->
        <div style="margin-top: 10px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
            <!-- 数据表 -->
            <baidu-map class="map"
                       :center="{lng:118.790644,lat:32.048021}"
                       :zoom='15'
                       :scroll-wheel-zoom='true'
            >
                <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
                <bm-marker :position="{lng:118.797786,lat:32.035348}" :dragging="true" animation='BMAP_ANIMATION_BOUNCE'>
                    <bm-label content='yx-soft' :labelStyle="{color:'red',fontSize:'12px'}" :offset="{width:-35,height:30}" />
                </bm-marker>

            </baidu-map>
        </div>

        <!-- pop对话框 -->
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                交易账号：{{oneTransDetail.cardAcc}}<br>
                POS流水：{{oneTransDetail.posSerial}}<br><br>
                {{oneTransDetail}}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <!-- pop对话框 -->
        <el-dialog
                :title="title"
                :visible.sync="dlgSalesSlipVisible"
                center
                class="dlg-showImg"
                >
            <div class="alignCenter">
                <el-image
                        style="width: 200px; height: 300px"
                        :src="urlSalesSlipImg">

                </el-image>
                <!--
                <el-popover
                        placement="right"
                        title=""
                        trigger="click">
                    <el-image slot="reference" :src="urlSalesSlipImg" :alt="urlSalesSlipImg" style="max-height: 300px;max-width: 200px"></el-image>
                    <el-image :src="urlSalesSlipImg"></el-image>
                </el-popover>
                -->

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dlgSalesSlipVisible = false">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    // name 组件名
    // data return 组件内的变量声明
    // created:html加载完成前 执行。执行顺序:父组件-子组件
    // mounted:html加载完成后 执行。执行顺序:子组件-父组件
    // methods:事件方法
    // watch:去监听一个值的变化，然后执行相对应的函数
    // computed:computed是属性调用，而methods是函数调用，computed带有缓存功能，而methods不是
    export default {
        name: "BillTotal",
        //组件中的data和实例中的不一样，实例中的data是一个对象，而组件中的data则是一个方法并且返回一个对象
        data() {
            //所有的变量都是写在data 的return里面
            //使用return包裹后数据中变量只在当前组件中生效,不会影响其他组件。
            return {
                searchValue: {  // 高级搜索用到的条件
                    merchName: null,
                    mid : null,
                    tid : null,
                    channel : null,
                    transType : null,
                    transDateScope : null,

                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null
                },
                title: '',  // 对话框的标题
                importDataBtnText: '导入数据',           // 导入数据 按钮文本 绑定变量
                importDataBtnIcon: 'el-icon-upload2',   // 导入数据 按钮图标 绑定变量
                importDataDisabled: false,              // 导入数据 按钮禁用 绑定变量
                showAdvanceSearchView: false,           // 高级搜索 视图隐藏 绑定变量
                loading: false,         // 加载提示 v-loading 变量
                popVisible: false,      // 新增员工对话框 部门弹出显示 变量
                popVisible2: false,     // 高级搜索搜索框 部门弹出显示 变量
                dialogVisible: false,   // 新增员工对话框 显示变量
                dlgSalesSlipVisible : false,
                urlSalesSlipImg : '',
                total: 0,       // 总计 变量
                page: 1,        // 页数 变量
                size: 10,       // 每页大小 变量
                keyword: '',    // 员工姓名输入框 关键词 变量
                allDeps: [],    // 部门集合 变量
                nations: [],    // 民族
                joblevels: [],  // 职称
                politicsstatus: [], // 政治面貌
                positions: [],  // 新增员工和工具栏 职位选择
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'], // 新增员工 学历选择
                options: [],    // unused
                emps: [],       // 员工数组 变量
                transTypes: [], // 交易类型 集合
                transRetcodes: [], // 返回码 集合
                acqChannels :[],   // 交易渠道 集合
                transArr: [],   // 交易对象 数组变量
                oneTransDetail: {        // 交易对象 变量 对话框使用
                    merchName:'',
                    mid:'',
                    tid:'',
                    posId:'',
                    sysSerial:'',
                    transType:'',
                    retcode:'',
                    sysDate:'',
                    sysTime:'',
                    cardAcc:'',
                    cardType:'',
                    validDate:'',
                    amount:'',
                    midSetbat:'',
                    posSetbat:'',
                    posType:'',
                    posSerial:'',
                    hostDate:'',
                    hostTime:''
                },
                transJnlKey: {
                    sysDate:'',
                    sysTime:'',
                    sysSerial:''
                },
                emp: {  // 员工对象
                    name: "javaboy",
                    gender: "男",
                    birthday: "1989-12-31",
                    idCard: "610122199001011256",
                    wedlock: "已婚",
                    nationId: 1,
                    nativePlace: "陕西",
                    politicId: 13,
                    email: "laowang@qq.com",
                    phone: "18565558897",
                    address: "深圳市南山区",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "劳务合同",
                    tiptopDegree: "本科",
                    specialty: "信息管理与信息系统",
                    school: "深圳大学",
                    beginDate: "2017-12-31",
                    workState: "在职",
                    workID: "00000057",
                    contractTerm: 2,
                    conversionTime: "2018-03-31",
                    notworkDate: null,
                    beginContract: "2017-12-31",
                    endContract: "2019-12-31",
                    workAge: null
                },
                inputDepName: '所属部门',   // 工具栏 所属部门 选择框 绑定的值
                defaultProps: { // 工具栏 所属部门 选择框 定义接收的props，等待父组件传递
                    children: 'children',
                    label: 'name'
                },
                // 新增员工 对话框 的规则
                rules: {
                }
            }
        },
        // 钩子函数，初始化页面完成后，再对dom节点进行相关操作
        mounted() {
            //vue渲染页面的时候，可能会对某些数据进行字典操作，比方性别，数据中是0和1，字典值是男和女，这个时候就需要在mounted进行“性别”字典的获取，然后页面自动渲染。
            this.initTransJnl();
            this.initTransTypes();
            this.initTransRetcodes();
            this.initTransAcqChannels();
            /**
            this.initEmps();    //初始化加载员工数据
            this.initData();    //初始化加载数据字典
            this.initPositions();//同上
            */
        },
        // 方法列表
        methods: {
            initTransJnl() {
                this.loading = true;
                let url = '/bill/details/?page=' + this.page + '&size=' + this.size;

                if (this.searchValue.merchName) {
                    url += '&merchName=' + this.searchValue.merchName;
                }
                if (this.searchValue.mid) {
                    url += '&mid=' + this.searchValue.mid;
                }
                if (this.searchValue.tid) {
                    url += '&tid=' + this.searchValue.tid;
                }
                if (this.searchValue.transType) {
                    url += '&transType=' + this.searchValue.transType;
                }
                if (this.searchValue.channel) {
                    url += '&channel=' + this.searchValue.channel;
                }
                if (this.searchValue.transDateScope) {
                    url += '&transDateScope=' + this.searchValue.transDateScope;
                }

                /*
                                url += (!this.searchValue.merchName) ? '&merchName=' + this.searchValue.merchName : '';
                                url += (!this.searchValue.mid) ? '&mid=' + this.searchValue.mid : '';
                                url += (!this.searchValue.tid) ? '&tid=' + this.searchValue.tid : '';
                                url += (!this.searchValue.acqChannels) ? '&acqChannels=' + this.searchValue.acqChannels : '';
                                url += (!this.searchValue.transType) ? '&transType=' + this.searchValue.transType : '';
                */
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.transArr = resp.data;
                        this.total = resp.total;
                        console.log("交易总笔数："+this.total);
                    }
                });
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name: "",
                    gender: "",
                    birthday: "",
                    idCard: "",
                    wedlock: "",
                    nationId: 1,
                    nativePlace: "",
                    politicId: 13,
                    email: "",
                    phone: "",
                    address: "",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "",
                    tiptopDegree: "",
                    specialty: "",
                    school: "",
                    beginDate: "",
                    workID: "",
                    contractTerm: 2,
                    conversionTime: "",
                    notworkDate: null,
                    beginContract: "",
                    endContract: "",
                    workAge: null
                }
                this.inputDepName = '';
            },
            showTransDetail(data) {
                this.title = '交易详情';

                this.transJnlKey.sysDate = data.sysDate;
                this.transJnlKey.sysTime = data.sysTime;
                this.transJnlKey.sysSerial = data.sysSerial;
                console.log(this.transJnlKey);

                this.postRequest('/bill/transDetail', this.transJnlKey).then(resp => {
                    if (resp) {
                        console.log(resp.obj);
                        // JSON.stringify   将 JavaScript 对象转换为 JSON 字符串
                        // JSON.parse       将 JSON字符串 转为一个JavaScript对象
                        this.oneTransDetail = resp.obj;
                    }
                    else {
                    }
                })

                this.dialogVisible = true;
            },
            showSalesSlip(data) {
                this.title = '电子签购单';

                this.transJnlKey.sysDate = data.sysDate;
                this.transJnlKey.sysTime = data.sysTime;
                this.transJnlKey.sysSerial = data.sysSerial;
                console.log(this.transJnlKey);

                this.urlSalesSlipImg = "http://192.168.59.148:88/yxsoft/M00/00/00/wKg7lF5vGHaAM4aJAAoEOaJ22jY879_big.jpg";

                /**
                this.postRequest('/bill/transDetail', this.transJnlKey).then(resp => {
                    if (resp) {
                        console.log(resp.obj);
                        // JSON.stringify   将 JavaScript 对象转换为 JSON 字符串
                        // JSON.parse       将 JSON字符串 转为一个JavaScript对象
                        this.oneTransDetail = resp.obj;
                    }
                    else {
                    }
                })
                 */

                this.dlgSalesSlipVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/employee/basic/", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/employee/basic/", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            getMaxWordID() {
                this.getRequest("/employee/basic/maxWorkID").then(resp => {
                    if (resp) {
                        this.emp.workID = resp.obj;
                    }
                })
            },
            // 请求数据字典
            initData() {
            },
            initTransTypes() {
                this.getRequest('/bill/transType').then(resp => {
                    if (resp) {
                        this.transTypes = resp;
                        window.sessionStorage.setItem("transTypes", JSON.stringify(resp));
                    }
                })
            },
            initTransRetcodes() {
                this.getRequest('/bill/transRetcode').then(resp => {
                    if (resp) {
                        this.transRetcodes = resp;
                        window.sessionStorage.setItem("transRetcodes", JSON.stringify(resp));
                    }
                })
            },
            initTransAcqChannels() {
                this.getRequest('/bill/acqChannel').then(resp => {
                    if (resp) {
                        this.acqChannels = resp;
                        window.sessionStorage.setItem("acqChannels", JSON.stringify(resp));
                    }
                })
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTransType(row, column) {
                for(let i=0; i<this.transTypes.length; i++) {
                    if(this.transTypes[i].id==row.transType) {
                        return this.transTypes[i].name;
                    }
                    return row.transType;
                }
            },
            funFmtTransRetcode(row, column) {
                for(let i=0; i<this.transRetcodes.length; i++) {
                    if(this.transRetcodes[i].code==row.retcode) {
                        return this.transRetcodes[i].name;
                    }
                }
                return row.retcode;
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let dt = row.hostDate;
                if(dt.length==8) {
                    dt = dt.substring(0,4) +"-"+ dt.substring(4,6) +"-"+ dt.substring(6,8);
                }
                return dt;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.hostTime;
                if(tm.length==6) {
                    tm = tm.substring(0,2) +":"+ tm.substring(2,4) +":"+ tm.substring(4,6);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTransJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTransJnl();
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加员工';
                this.getMaxWordID();
                this.dialogVisible = true;
            },
            /*************************************
             * 初始化
             * 参数 type 是否高级搜索 可省略
            *************************************/
            initEmps(type) {
                this.loading = true;
                let url = '/employee/basic/?page=' + this.page + '&size=' + this.size;
                if (type && type == 'advanced') {
                    if (this.searchValue.politicId) {
                        url += '&politicId=' + this.searchValue.politicId;
                    }
                    if (this.searchValue.nationId) {
                        url += '&nationId=' + this.searchValue.nationId;
                    }
                    if (this.searchValue.jobLevelId) {
                        url += '&jobLevelId=' + this.searchValue.jobLevelId;
                    }
                    if (this.searchValue.posId) {
                        url += '&posId=' + this.searchValue.posId;
                    }
                    if (this.searchValue.engageForm) {
                        url += '&engageForm=' + this.searchValue.engageForm;
                    }
                    if (this.searchValue.departmentId) {
                        url += '&departmentId=' + this.searchValue.departmentId;
                    }
                    if (this.searchValue.beginDateScope) {
                        url += '&beginDateScope=' + this.searchValue.beginDateScope;
                    }
                } else {
                    url += "&name=" + this.keyword;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                        console.log(this.total);
                    }
                });
            }
        }
    }
</script>

<style>

    .pageNormal {
        font-size: 13px;
        font-family: 微软雅黑;
    }

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }

    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .style-input-width {
        max-width: 120px;
    }

    .map {
        width: 100%;
        height: 500px;
    }
</style>